import { FormattedMessage } from 'react-intl'
// import { ACCOMMODATION_RESERVATION_SECTION_LINK } from 'constants/links'
// import { useApp } from 'store/steps'
import { InfoWrapper } from './style'
// import Link from 'components/shared/Link'

const AccommodationAdditionalPromoInfo = () => (
    // show after promotion end

    <InfoWrapper color="success">
        <FormattedMessage
            id="promo.accommodation_additional_promo_info"
            defaultMessage="<strong>Drugi nocleg w kwietniu za 50zł!</strong> Przy zakupie 2-dniowego noclegu w Suntago Village w dniach 17-30.04, tańszy nocleg otrzymasz za 50 zł."
            values={{
                strong: (chunks: string[]) => (
                    <>
                        <strong>{chunks}</strong>
                        <br />
                    </>
                ),
                // eslint-disable-next-line id-length
                // show after promo:
                // a: (chunks: string[]) => (
                //     <Link
                //         icon={null}
                //         variant="success"
                //         textVariant="bodySmall"
                //         path={ACCOMMODATION_RESERVATION_SECTION_LINK}
                //         target={'_blank'}
                //         isUnderlined
                //     >
                //         {chunks}
                //     </Link>
                // ),
            }}
        />
        {/* use below FormatMessage in this condition after promo end */}
        {/* {!isCreatorAccommodation && (
        )} */}
        <FormattedMessage
            id="promo.accommodation.discount_info"
            defaultMessage="<span>Nocując w Suntago Village, zyskujesz dodatkowo 10% zniżki na bilet do parku Suntago!</span>"
            values={{
                span: (chunks: string[]) => (
                    <>
                        <br />
                        <br />
                        {chunks}
                    </>
                ),
            }}
        />
    </InfoWrapper>
)

export default AccommodationAdditionalPromoInfo
